import $ from 'jquery';

/*global authoritycode */

/**
 * @typedef {object} Site
 * @property {string} code
 * @property {string} section
 * @property {string} from
 * @property {string} to
 * @property {string} geometry
 * @property {number} caseIndex
 * @property {number} siteIndex
 */

/**
 * @type {Site[]}
 */
const sites = [];

export function registerSite(code, section, from, to, geometry, caseIndex, siteIndex) {
    sites.push({
        code: code,
        section: section,
        from: from,
        to: to,
        geometry: geometry,
        caseIndex: caseIndex,
        siteIndex: siteIndex
    });
}

/**
 * @param {string|number} caseIndex
 * @param {string|number} siteIndex
 * @returns {?string}
 */
export function getSiteGeometry(caseIndex, siteIndex) {
    if (typeof caseIndex === 'string') {
        caseIndex = parseInt(caseIndex, 10);
    }
    if (typeof siteIndex === 'string') {
        siteIndex = parseInt(siteIndex, 10)
    }
    const result = sites.filter(site => site.caseIndex === caseIndex && site.siteIndex === siteIndex);
    if (result.length === 1) {
        return result[0].geometry;
    }
    return null;
}

/**
 * @returns {boolean}
 */
export function hasNoGeometry() {
    for (const element of sites) {
        if (element.code || element.geometry) {
            return false;
        }
    }
    return true;
}

export function hasAuthorityCode() {
    return null !== authoritycode && undefined !== authoritycode && authoritycode > 100;
}

/**
 * @callback forEachSiteCallback
 * @param {Site} site
 */

/**
 * Iterate over all registered sites.
 * @param {forEachSiteCallback} callback
 */
export function forEachSite(callback) {
    sites.forEach(callback);
}

export function getSiteVal(caseIndex, siteIndex, name) {
    const selector = `input[name="caseSetBean.cases[${caseIndex}].sites[${siteIndex}].${name}"]`;
    if (caseIndex === '0') {
        return $(selector + `, input[name="caseBean.sites[${siteIndex}].${name}"]`).val();
    }
    return $(selector).val();
}

export function setSiteVal(caseIndex, siteIndex, name, value) {
    const selector = `input[name="caseSetBean.cases[${caseIndex}].sites[${siteIndex}].${name}"]`;
    if (caseIndex === 0) {
        $(selector + `, input[name="caseBean.sites[${siteIndex}].${name}"]`).val(value);
    }
    else {
        $(selector).val(value);
    }
}
